var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.6A6.667 6.667 0 1 0 8 1.267 6.667 6.667 0 0 0 8 14.6z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.507 8 8.5 7.647v-2.26h.24c.54 0 .98.473.98 1.053 0 .273.227.5.5.5s.5-.227.5-.5c0-1.133-.887-2.053-1.98-2.053H8.5V4c0-.273-.227-.5-.5-.5s-.5.227-.5.5v.387h-.433c-.987 0-1.794.833-1.794 1.853 0 1.193.694 1.573 1.22 1.76l1.007.353v2.254h-.24c-.54 0-.98-.474-.98-1.054 0-.273-.227-.5-.5-.5s-.5.227-.5.5c0 1.134.887 2.054 1.98 2.054h.24V12c0 .273.227.5.5.5s.5-.227.5-.5v-.387h.433c.987 0 1.794-.833 1.794-1.853-.007-1.2-.7-1.58-1.22-1.76zm-2.68-.94c-.34-.12-.547-.233-.547-.813 0-.474.353-.854.793-.854h.434V7.3l-.68-.24zm2.106 3.553H8.5V8.707l.673.233c.34.12.547.233.547.813 0 .474-.353.86-.787.86z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.f7cc8c61c9497f00cd36efa79c5c1d5c.svg";
export { ForwardRef as ReactComponent };